import * as React from 'react';
import cx from 'classnames';
import Button from 'components/Button';
import styles from './Card.css';
const TOOLTIP_OFFSET_TOP = 24;
class Card extends React.Component {
    constructor(props) {
        super(props);
        this.tooltipRef = c => (this.tooltip = c);
        this.state = {
            width: 0,
            height: 0
        };
        this.getStyle = this.getStyle.bind(this);
        this.computeClientRect = this.computeClientRect.bind(this);
    }
    componentDidMount() {
        !this.props.manualStyle && this.computeClientRect();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.manualStyle && !this.props.active && nextProps.active) {
            const timer = window.requestAnimationFrame || window.setTimeout;
            timer(() => this.computeClientRect());
        }
    }
    computeClientRect() {
        this.setState({
            width: this.tooltip.offsetWidth,
            height: this.tooltip.offsetHeight
        });
    }
    resolveToolTipPosition() {
        const { position, anchor } = this.props;
        if (position === 'bottom-center' && anchor instanceof Element) {
            const anchorBottomOffset = window.innerHeight - anchor.getBoundingClientRect().bottom;
            if (anchorBottomOffset <= this.state.height + 25) {
                return 'top-center';
            }
        }
        return position;
    }
    getStyle() {
        const { anchor, theme } = this.props;
        if (!(anchor instanceof Element)) {
            if (__DEBUG_ENV__) {
                // tslint:disable:no-console
                console.error('Expected either manualStyle or anchor prop');
            }
            return {};
        }
        const updatedPosition = this.resolveToolTipPosition();
        const anchorPosition = anchor.getBoundingClientRect();
        const scrollY = typeof window.scrollY !== 'undefined' ? window.scrollY : window.pageYOffset;
        const scrollX = typeof window.scrollX !== 'undefined' ? window.scrollX : window.pageXOffset;
        const top = scrollY + anchorPosition.top;
        const left = scrollX + anchorPosition.left;
        const topOffset = anchorPosition.height / 2 - (theme === 'light' ? TOOLTIP_OFFSET_TOP : this.state.height / 2);
        const leftOffset = theme === 'light' ? 0 : anchorPosition.width / 2 - this.state.width / 2;
        const margin = this.props.margin || 16;
        // default position is 'right' because we set that in the default props option
        const style = {
            top: top + topOffset,
            left: left + anchorPosition.width + margin
        };
        switch (updatedPosition) {
            case 'right':
                style.top = top + topOffset;
                style.left = left + anchorPosition.width + margin;
                break;
            case 'left':
                style.top = top + topOffset;
                style.left = left - this.state.width - margin;
                break;
            case 'top':
                style.top = top - this.state.height - margin;
                style.left = left + leftOffset;
                break;
            case 'bottom':
                style.top = top + anchorPosition.height + margin;
                style.left = left + leftOffset;
                break;
            case 'bottom-right':
                style.top = top + anchorPosition.height + margin;
                style.left = left - this.state.width + anchorPosition.width;
                break;
            case 'top-center':
                style.top = top - this.state.height - margin;
                style.left = left - Math.round(this.state.width / 2) + margin;
                break;
            case 'bottom-center':
                style.top = top + anchorPosition.height + margin;
                style.left = left - Math.round(this.state.width / 2) + margin;
                break;
            case 'top-right':
                style.top = top - this.state.height - margin;
                style.left = left - this.state.width + anchorPosition.width;
                break;
            default:
                break;
        }
        return { transform: `translate(${style.left}px, ${style.top}px)` };
    }
    render() {
        const { className, active, animate, dismissible, theme, manualStyle, manualStyleValue, containerClassName, activeClassName } = this.props;
        const updatedPosition = this.resolveToolTipPosition();
        const cardStyle = cx(styles['tooltip'], styles[updatedPosition], {
            [styles['active']]: active,
            [activeClassName || '']: active,
            [styles['animate-move']]: animate,
            [styles['dismissible']]: dismissible,
            [styles['light']]: theme === 'light'
        }, className);
        const style = manualStyle ? manualStyleValue || {} : this.getStyle();
        return (<div ref={this.tooltipRef} className={cardStyle} style={style} onMouseEnter={this.props.onMouseEnter} onMouseLeave={this.props.onMouseLeave}>
				<div className={cx(styles['container'], containerClassName)}>
					{this.props.children}
					{this.props.dismissible ? (<Button className={styles['dismiss-btn']} onClick={this.props.onDismiss}>
							✕
						</Button>) : null}
				</div>
			</div>);
    }
}
Card.defaultProps = {
    active: false,
    animate: false,
    dismissible: false,
    position: 'right',
    theme: 'dark',
    margin: 16
};
export default Card;
